import { call, put } from "redux-saga/effects";
import httpErrorHelpers from "../../services/httpUtilities/httpErrorHelpers";
import api from "../../services/httpUtilities/httpService";
import * as enrolGIRONowAction from "../actions/enrolGIRONow";

function* watcherGetDDAPolicy({ policyNumber,GiroReference }, effects) {
  try {
    const response = yield call(api.getDDAPolicy, policyNumber,GiroReference);
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.getDDAPolicySuccess(data));
    } else {
      const message = "Get DDA Policy Unsuccessful";
      yield put(enrolGIRONowAction.getDDAPolicyFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.getDDAPolicyFailure,
      effects
    );
  }
}

function* watcherCreateEDDA(
  { policyNumber, policyName, premium, bankID,transactionType, orderNumber,
    ewalletAmount,
    isRecurring },
  effects
) {
  try {
    const response = yield call(
      api.createEDDA,
      policyNumber,
      policyName,
      premium,
      bankID,
      transactionType, orderNumber,
      ewalletAmount,
      isRecurring
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.createEDDASuccess(data));
    } else {
      const message = "Create EDDA Failure";
      yield put(enrolGIRONowAction.createEDDAFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.createEDDAFailure,
      effects
    );
  }
}

function* watcherGetGIROBankList({transactionType}, effects) {
  try {
    const response = yield call(api.getGIROBankList,transactionType);
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.getGIROBankListSuccess(data));
    } else {
      const message = "Create EDDA Failure";
      yield put(enrolGIRONowAction.getGIROBankListFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.getGIROBankListFailure,
      effects
    );
  }
}

function* watcherGetGIROCallBackData(
  { id },
  effects
) {
  try {
    const response = yield call(
      api.getGiroCallBackData,
      id
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.getGiroCallBackDataSuccess(data));
    } else {
      const message = "Create EDDA Failure";
      yield put(enrolGIRONowAction.getGiroCallBackDataFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.getGiroCallBackDataFailure,
      effects
    );
  }
}

function* watcherGetGiroCallBackExist(
  { ddaRefNo,bankTransId },
  effects
) {
  try {
    const response = yield call(
      api.getGiroCallBackExist,
      ddaRefNo,bankTransId
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.getGiroCallBackExistSuccess(data));
    } else {
      const message = "Call Back Exist Failed";
      yield put(enrolGIRONowAction.getGiroCallBackExistFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.getGiroCallBackExistFailure,
      effects
    );
  }
}

function* watcherSubmitGiro(
  { ddaRefNo,bankTransId,payorName,payorNric,payorRelationship,attachedFile,isThirdParty,isMatch },
  effects
) {
  try {
    const response = yield call(
      api.submitGiro,
      ddaRefNo,bankTransId,payorName,payorNric,payorRelationship,attachedFile,isThirdParty,isMatch
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.submitGiroSuccess(data));
    } else {
      const message = "submit giro failed";
      yield put(enrolGIRONowAction.submitGiroFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.submitGiroFailure,
      effects
    );
  }
}

function* watcherGetGiroSubmitCallBackExist(
  { ddaRefNo,bankTransId },
  effects
) {
  try {
    const response = yield call(
      api.getGiroSubmitCallBackExist,
      ddaRefNo,bankTransId
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.getGiroSubmitCallBackExistSuccess(data));
    } else {
      const message = "Submit Call Back Exist Failed";
      yield put(enrolGIRONowAction.getGiroSubmitCallBackExistFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.getGiroSubmitCallBackExistFailure,
      effects
    );
  }
}

function* watcherEnroleGiro(
  { ddaRefNo, transactionRefNo },
  effects
) {
  try {
    const response = yield call(
      api.enroleGiro,
      ddaRefNo, transactionRefNo
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.enroleGiroSuccess(data));
    } else {
      const message = "enrol eGiro Failed";
      yield put(enrolGIRONowAction.enroleGiroFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.enroleGiroFailure,
      effects
    );
  }
}


function* watcherConfirmPayEddaGiRenewal(
  { orderNumber },
  effects
) {
  try {
    const response = yield call(
      api.confirmPayEddaGiRenewal,
      orderNumber
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(enrolGIRONowAction.confirmPayEddaGiRenewalSuccess(data));
    } else {
      const message = "confirmPayEddaGiRenewalFailure Failed";
      yield put(enrolGIRONowAction.confirmPayEddaGiRenewalFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      enrolGIRONowAction.confirmPayEddaGiRenewalFailure,
      effects
    );
  }
}


export {
  watcherGetDDAPolicy,
  watcherCreateEDDA,
  watcherGetGIROBankList,
  watcherGetGIROCallBackData,
  watcherGetGiroCallBackExist,
  watcherSubmitGiro,
  watcherGetGiroSubmitCallBackExist,
  watcherEnroleGiro,
  watcherConfirmPayEddaGiRenewal
};
